import { FC } from "react";
import { Datagrid, List, ListProps } from "react-admin";

import CustomPagination from "../../components/CustomPagination";
import EmptyDataText from "../../components/EmptyDataText";
import ListImage from "../../components/ListImage";
import ListUrlField from "../../components/ListUrlField";
import TimestampField from "../../components/TimestampField";
import useSharedStyles from "../../hooks/useSharedStyles";
import EnablePropertyCompanyButton from "./components/DeleteAdsButton";

const CustomBulkActions = (props: any) => <EnablePropertyCompanyButton label="Delete" {...props} />;

const AdsList: FC<ListProps> = (props) => {
  const { styles } = useSharedStyles();

  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      exporter={false}
      bulkActionButtons={<CustomBulkActions />}
    >
      <Datagrid rowClick="edit" empty={<EmptyDataText message="No ads yet!" />}>
        <ListUrlField source="url" label="External Url" sortable={false} cellClassName={styles.truncate1} />
        <ListUrlField source="deepUrl" label="Internal Url" sortable={false} cellClassName={styles.truncate1} />
        <ListImage source="image.src" label="Image" sortable={false} />
        <TimestampField source="expiryDate" label="Expiry Date" />
        <TimestampField source="createdAt" label="Created At" />
      </Datagrid>
    </List>
  );
};

export default AdsList;
